export default __webpack_public_path__ + "static/how-its-work-74cb4658b01e7ca4edb2d0ddccdc8482.png";